import * as React from 'react';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import pt from 'dayjs/locale/pt-br';
import { ptBR } from '@mui/x-date-pickers/locales';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dateHelper from '../../utils/date-helper';

interface Props {
  label: string;
  onChange: (date: string) => void;
  value?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}

export default function DatePickerInput({
  label,
  onChange,
  value,
  error,
  helperText,
  required,
}: Props) {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={pt}
      localeText={
        ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <DatePicker
        label={label}
        value={value ? dayjs(value) : null}
        inputFormat="DD/MM/YYYY"
        onChange={(newValue) => {
          onChange(dateHelper.getStandardizedDate(newValue));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            variant="standard"
            error={error}
            helperText={helperText}
            required={required}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {value && (
                    <InputAdornment position="end">
                      <IconButton edge="end" onClick={() => onChange('')}>
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  )}
                  {params.InputProps?.endAdornment}

                </>
              ),
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
